


































































import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
import Cryptoicon from "vue-cryptoicon";
import icons from "vue-cryptoicon/src/icons";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import store from "@/store";

Cryptoicon.add(icons);
Vue.use(Cryptoicon);

@Component({
  components: {
    BaseNav,
    BaseDropdown,
    CloseButton
  }
})
export default class AppHeader extends Vue {
  selectedLang = "";
  year = new Date().getFullYear();

  // compute language
  get language() {
    // first get the stored lang
    const storeLang = store.getters.selectedLanguage;
    if (typeof storeLang === "undefined") {
      console.log("no stored lang", navigator.language.split("-")[0]);
      return navigator.language.split("-")[0];
    } else {
      console.log("stored lang", storeLang);
      return storeLang;
    }
  }
}
